import React, { useEffect, useState } from "react";
import LightGallery from "lightgallery/react";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import { getFileUrl } from "../../utils/GetAuthUser";

import { createSelector } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { getAllContestThunk as onGetAllContestThunk } from "../../slices/contest/thunk";

export const UserGallery = () => {
  const dispatch = useDispatch();
  const [images, setImages] = useState([]);

  const fileUrl =getFileUrl();

  // Selector for contest state
  const selectContestState = (state) => state.contest;
  const contestSelector = createSelector(selectContestState, (contest) => ({
    isLoading: contest.isLoading,
    contestList: contest.contestList,
  }));

  const { contestList } = useSelector(contestSelector);

  useEffect(() => {
    dispatch(onGetAllContestThunk({ statusCode: 0 }));
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(contestList) && contestList.length > 0) {
      const imageArray = contestList.map((item, index) => ({
        id: item.id || index + 1,
        image: item.contestImage
          ? `${fileUrl}/${item.contestImage}`
          : `${fileUrl}/default.jpg`,
      }));

      setImages(imageArray);
    } else {
      setImages([]);
    }
  }, [contestList, fileUrl]);

  return (
    <div className="w-full">
      <LightGallery
        speed={500}
        plugins={[lgThumbnail, lgZoom]}
        elementClassNames="columns-1 xs:columns-2 md:columns-3 lg:columns-4 gap-4"
      >
        {Array.isArray(images) && images.length > 0 ? (
          images.map((item) => (
            <a key={item.id} href={item.image} className="mb-4 block">
              <img
                src={item.image}
                alt="Contest"
                className="w-full h-auto rounded-lg"
              />
            </a>
          ))
        ) : (
          <p className="text-center text-gray-500">No images available</p>
        )}
      </LightGallery>
    </div>
  );
};
